import "./stablishment_list.page.style.scss";
import { FC } from "react";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import PaginatorComponent from "../../../components/paginator/PaginatorComponent";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import ButtonComponent from "../../../components/button/ButtonComponent";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";
import NotResultsComponent from "../../../components/noResults/NoResultsComponent";
import EntitiesConstants from "../../../utils/EntitiesConstants";
import StablishmentEntity from "../../../../domain/entities/StablishmentEntity";
import useStablishmentListViewModel from "./stablishment_list.page.view_model";

const StablishmentListPage: FC<{}> = () => {
    const {
        formInfo,
        result,
        loadingDownload,
        i18n,
        _handleSearch,
        _handleChangeTextSearch,
        _handleOnChangePage,
        _handleOnClickDeleteStablishment,
        _handleOnClickUpdateStablishment,
        _handleOnCreateSingleStablishment,
    } = useStablishmentListViewModel();

    const { register, handleSubmit } = formInfo;

    return <div className="stablishment_list_page">
        <LayoutComponent title={i18n("Establecimientos")}>
            <div className="container py-5">
                <form onSubmit={handleSubmit(_handleSearch)}>
                    <div className="row">
                        <div className="col-md-10">
                            <input type="text" className="form-control" placeholder={i18n("Buscar establecimientos...")} {...register("query")} onKeyUp={_handleChangeTextSearch} />
                        </div>
                        <div className="col-md-2">
                            <ButtonComponent
                                className="w-100 d-flex justify-content-center"
                                type="submit"
                                design="primaryOutline"
                                text={i18n("Buscar")}
                                icon={<span className="material-symbols-outlined">search</span>}
                            />
                        </div>
                    </div>
                </form>

                <div className="row mt-4">
                    <div className="col-md-12 d-flex justify-content-end">
                        <ButtonComponent
                            onClick={_handleOnCreateSingleStablishment}
                            design="primaryOutline"
                            text={i18n("Crear Establecimiento")}
                            icon={<span className="material-symbols-outlined">add</span>}
                        />
                    </div>
                </div>

                {result == undefined ? (
                    <LoadingComponent />
                ) : (
                    <>
                        {result?.data && result.data.length > 0 ? (
                            <>
                                <div className="table-responsive mt-4">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>{i18n(EntitiesConstants.StablishmentEntityName)}</th>
                                                <th>{i18n(EntitiesConstants.StablishmentEntityAddress)}</th>
                                                <th>{i18n("Acciones")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {result.data.map((stablishment: StablishmentEntity) => (
                                                <tr key={stablishment.id}>
                                                    <td>{stablishment.name}</td>
                                                    <td>{stablishment.address}</td>
                                                    <td>
                                                        <div className="d-flex gap-2">
                                                            <ButtonComponent
                                                                onClick={() => _handleOnClickUpdateStablishment(stablishment)}
                                                                design="primary"
                                                                text={i18n("Editar")}
                                                                icon={<span className="material-symbols-outlined">edit</span>}
                                                            />
                                                            <ButtonComponent
                                                                onClick={() => _handleOnClickDeleteStablishment(stablishment)}
                                                                design="dangerOutline"
                                                                text={i18n("Eliminar")}
                                                                icon={<span className="material-symbols-outlined">delete</span>}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mt-4">
                                    <PaginatorComponent
                                        resultData={result}
                                        onChangePage={_handleOnChangePage}
                                    />
                                </div>
                            </>
                        ) : (
                            <NotResultsComponent />
                        )}
                    </>
                )}
            </div>
        </LayoutComponent>
    </div>;
};

export default StablishmentListPage;